export const PRIMARY_COLOR = "#0D1321";
export const SECONDARY_COLOR = "#3BE07E";
export const HEADER_COLOR = "#1D2D44";

export const SIDEBAR_COLOR = "#3783FB";

export const BG_COLOR = "#F3F3F3";

export const WHITE_COLOR = "#FFFFFF";
export const BLACK_COLOR = "#111111";

export const LOGIN_BG_COLOR = "#F9F9F9";
export const LIGHT_GREY_BG_MODAL = "#E5E5E5";
export const BUTTON_BG_COLOR = "dodgerblue";
export const REPORT_BG_COLOR = "#F3F3F3";
export const LIGHT_TEXT_COLOR = "#7F7F7F";
